<!--
 * @Desc: 项目根组件
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-09-01 09:36:35
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-iframe">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive">
                <!-- 这里是会被缓存的视图组件，比如 Home！ -->
            </router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
    </div>
</template>
<script>
    import utils from "@/api/Utils.js"
    export default {
        data() {
            return {
                isCollapsed: false, // 侧栏开关
                menuData: [], // 左侧菜单
                breadCrumbList: [], // 面包屑
                title: '首页', // 标题
                btns: [], // 功能按钮组
                active: 'home',
            };
        },
        computed: {
        },
        // watch:{
        //     $route(val){
        //         this.pageChange(val.name);
        //     }
        // },
        created: function () {
            // console.log(this.$route)
            if ( this.$route.name != this.active ) {
                // this.pageChange(this.$route.name);
                this.active = this.$route.name;
            }
            this.getCate()
            if(utils.ios() || utils.android()){
                if (location.origin.indexOf('localhost') != -1){
                    return
                }
                // 移动端
                if (location.origin.indexOf('shanmuzhi') != -1){
                    if (window.location.href != 'http://schoolinfoh5.shanmuzhi.com/#/') {
                        window.location.href = 'http://schoolinfoh5.shanmuzhi.com/#/'
                    }
                } else if(location.origin.indexOf('137idea') != -1) {
                    if (window.location.href != 'http://hengyuanh5.137idea.com/#/') {
                        window.location.href = 'http://hengyuanh5.137idea.com/#/'
                    }
                } else {
                    if (window.location.href != 'http://mobile.lfhyxx.cn/#/') {
                        window.location.href = 'http://mobile.lfhyxx.cn/#/'
                    }
                }
            } else {
                if (location.origin.indexOf('localhost') != -1){
                    return
                }
            }
        },
        methods: {
            pageChange(event) {
                this.$router.push(`/${event}/index`);
                this.active = event;
            },
            // 获取菜单
            getCate() {
                let that = this
                this.$api.index
                    .gwCate({})
                    .then((res) => {
                        that.Cookies.set('menuList', JSON.stringify(res.result.cate_arr), { expires: 365 })
                        that.Cookies.set('webTime', JSON.stringify(res.result.current_time).replace(/-/g, '/'), { expires: 365 })
                    })
                    .catch((res) => {
                        console.log(res)
                    });
            },
        },
    }
</script>